import { Subscription } from 'rxjs';
import { Component, Input, Output, ViewChild, EventEmitter, NgZone, ViewEncapsulation } from '@angular/core';
import { VisibaAudioAnalyser } from './mediaTest.component';
import { UserMedia } from '../Classes/UserMedia';
import { SpaContext } from '../Classes/spacontext';
import { Helper } from '../Common/Helpers/helper';
import { TranslateService } from '../Common/Services/translate.service';
import { AudioPlayerService } from '../Common/Services/audioPlayer.service';
import { SpaLogger } from '../Common/Classes/Global/spalogger.class';
import { CookieHelper } from '../Common/Helpers/cookie.helper';

@Component({
	standalone: false,
	selector: 'media-test-mini',
	template: /*language=html*/ `
		<div class="row" [hidden]="currentStates.camera === 'none'">
			<!-- Evaluation message -->
			<div *ngIf="showCompleted === true">
				<div class="testEvaluation">
					<div class="row">
						<div class="switchContentHolder">
							<div class="switchContent evaluation_start">
								<visiba-succesBox
									*ngIf="showCompleted === true"
									title="{{ 'LicenceHolder.Component.MediaTestMini.Title.Done' | translate }}"
									info="{{ evaluationText }}"
									button="{{ 'LicenceHolder.Component.MediaTestMini.Button.Done' | translate }}"
									(onToggle)="onEvaluationNextFunction()"
								>
								</visiba-succesBox>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="tests" [hidden]="showCompleted">
				<!-- Camera -->
				<div class="testBox">
					<div class="testCamera js-test-camera">
						<div class="inner">
							<visiba-svg a="CameraCircleOn" class="testIcon"></visiba-svg>
							<div class="switchContentHolder">
								<div class="switchContent camera_start" *ngIf="currentStates['camera'] === 'start'">
									<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Video' | translate }}</h2>
									<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.TestVideo' | translate }}</p>

									<div class="btnWrapper">
										<div class="btn" (click)="setCurrentState('camera', 'failed')">{{ 'Common.Button.No' | translate }}</div>
										<div class="btn" (click)="setCurrentState('camera', 'completed')">
											{{ 'Common.Button.Yes' | translate }}
										</div>
									</div>
								</div>

								<div class="switchContent camera_failed" *ngIf="currentStates['camera'] === 'failed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Video' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.VideoHelp' | translate }}</p>

										<div class="btnWrapper">
											<div class="btn" (click)="setCurrentState('camera', 'failed')">
												{{ 'Common.Button.No' | translate }}
											</div>
											<div class="btn" (click)="setCurrentState('camera', 'completed')">
												{{ 'Common.Button.Yes' | translate }}
											</div>
										</div>
									</div>
								</div>

								<div class="switchContent camera_completed" *ngIf="currentStates['camera'] === 'completed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Video' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.Functional' | translate }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="innerColumn" *ngIf="currentStates['camera'] !== 'completed'">
							<div class="portrait">
								<div class="videoWrap">
									<video autoplay="autoplay" style="width: 100%; display: none;" [ngStyle]="localVideoStyle"></video>

									<visiba-svg a="Loader" class="videoLoaderIcon"></visiba-svg>
								</div>
							</div>

							<visiba-select
								*ngIf="currentStates['camera'] !== 'completed' && devices.videoinput.length > 0"
								icon="CameraCircleOn"
								(onChange)="updateVideo($event)"
								[(ngModel)]="chosenVideoinputDeviceId"
								placeholder="Common.Devices.Videoinput"
								label="label"
								value="deviceId"
								[options]="devices.videoinput"
								[clearButton]="false"
							></visiba-select>
						</div>

						<div class="statusIconArea">
							<visiba-svg a="Check" class="statusIcon check" [class.show]="currentStates['camera'] === 'completed'"></visiba-svg>
							<visiba-svg a="Warning" class="statusIcon warning" [class.show]="currentStates['camera'] === 'failed'"></visiba-svg>
						</div>
					</div>
				</div>

				<!-- Microphone -->
				<div class="testBox">
					<div class="testMicrophone js-test-microphone">
						<div class="inner">
							<div class="iconWrapper">
								<visiba-svg a="MicrophoneCircleOn" class="testIcon"></visiba-svg>
								<div class="circlesWrapper">
									<div class="svgbg"></div>
									<div class="circles"></div>
								</div>
							</div>
							<div class="switchContentHolder">
								<div class="switchContent microphone_start" *ngIf="currentStates['microphone'] === 'start'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Microphone' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.TestMicrophone' | translate }}</p>
									</div>
								</div>
								<div class="switchContent microphone_failed" *ngIf="currentStates['microphone'] === 'failed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Microphone' | translate }}</h2>
										<p class="desc">
											<visiba-svg a="Warning"></visiba-svg
											>{{ 'LicenceHolder.Component.MediaTestMini.Phrase.MicrophoneHelp' | translate }}
										</p>
									</div>
								</div>
								<div class="switchContent microphone_completed" *ngIf="currentStates['microphone'] === 'completed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Microphone' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.Functional' | translate }}</p>
									</div>
								</div>
							</div>
						</div>

						<div class="innerColumn" *ngIf="currentStates['microphone'] !== 'completed' && devices.audioinput.length > 0">
							<visiba-select
								icon="MicrophoneCircleOn"
								(onChange)="updateAudioInput($event)"
								[(ngModel)]="chosenAudioinputDeviceId"
								placeholder="Common.Devices.Audioinput"
								label="label"
								value="deviceId"
								[options]="devices.audioinput"
								[clearButton]="false"
							></visiba-select>
						</div>

						<div class="statusIconArea">
							<visiba-svg a="Check" class="statusIcon check" [class.show]="currentStates['microphone'] === 'completed'"></visiba-svg>
							<visiba-svg a="Warning" class="statusIcon warning" [class.show]="currentStates['microphone'] === 'failed'"></visiba-svg>
						</div>
					</div>
				</div>

				<!-- Sound -->
				<div class="testBox">
					<div class="testSound js-test-sound">
						<div class="inner">
							<div class="iconWrapper">
								<visiba-svg a="SpeakerCircle" class="testIcon" (click)="toggleTestSound()"></visiba-svg>
								<div class="circlesWrapper">
									<div class="svgbg"></div>
									<div class="circles"></div>
								</div>
							</div>
							<div class="switchContentHolder">
								<div class="switchContent sound_start" *ngIf="currentStates['sound'] === 'start'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Audio' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.TestAudio' | translate }}</p>
									</div>
									<div class="btnWrapper">
										<div class="btn span6" (click)="setCurrentState('sound', 'failed')">
											{{ 'Common.Button.No' | translate }}
										</div>
										<div class="btn span6 offset1" (click)="setCurrentState('sound', 'completed'); pauseAudio()">
											{{ 'Common.Button.Yes' | translate }}
										</div>
									</div>
								</div>
								<div class="switchContent sound_failed" *ngIf="currentStates['sound'] === 'failed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Audio' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.AudioHelp' | translate }}</p>
									</div>
									<div class="btnWrapper">
										<div class="btn span6" (click)="setCurrentState('sound', 'failed')">
											{{ 'Common.Button.No' | translate }}
										</div>
										<div class="btn span6 offset1" (click)="setCurrentState('sound', 'completed'); pauseAudio()">
											{{ 'Common.Button.Yes' | translate }}
										</div>
									</div>
								</div>
								<div class="switchContent sound_completed" *ngIf="currentStates['sound'] === 'completed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Audio' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.Functional' | translate }}</p>
									</div>
								</div>
							</div>
						</div>

						<div class="innerColumn" *ngIf="currentStates['sound'] !== 'completed' && devices.audiooutput.length > 0 && false">
							<visiba-select
								icon="Megaphone"
								(onChange)="updateAudioOutput($event)"
								[(ngModel)]="chosenAudiooutputDeviceId"
								placeholder="Common.Devices.Audiooutput"
								label="label"
								value="deviceId"
								[options]="devices.audiooutput"
								[clearButton]="false"
							></visiba-select>
						</div>

						<div class="statusIconArea">
							<visiba-svg a="Check" class="statusIcon check" [class.show]="currentStates['sound'] === 'completed'"></visiba-svg>
							<visiba-svg a="Warning" class="statusIcon warning" [class.show]="currentStates['sound'] === 'failed'"></visiba-svg>
						</div>
					</div>
				</div>

				<!-- Network -->
				<div class="testBox">
					<div class="testNetwork js-test-network">
						<div class="inner">
							<visiba-svg a="WifiCircle" class="testIcon"></visiba-svg>
							<div class="switchContentHolder">
								<div class="switchContent network_start" *ngIf="currentStates['network'] === 'start'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Network' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.TestNetwork' | translate }}</p>
									</div>
								</div>
								<div class="switchContent network_failed" *ngIf="currentStates['network'] === 'failed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Network' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.NetworkHelp' | translate }}</p>
									</div>
								</div>
								<div class="switchContent network_completed" *ngIf="currentStates['network'] === 'completed'">
									<div class="row">
										<h2 class="title">{{ 'LicenceHolder.Component.MediaTestMini.Title.Network' | translate }}</h2>
										<p class="desc">{{ 'LicenceHolder.Component.MediaTestMini.Phrase.Functional' | translate }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="statusIconArea">
							<visiba-svg a="Check" class="statusIcon check" [class.show]="currentStates['network'] === 'completed'"></visiba-svg>
							<visiba-svg a="Warning" class="statusIcon warning" [class.show]="currentStates['network'] === 'failed'"></visiba-svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['../Css/Components/MediaTestMini.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class MediaTestMiniComponent extends UserMedia {
	@Output() stateUpdate = new EventEmitter();
	@Input('openOnStart') openOnStart: boolean = true;
	@Input('stream') activeStream?: MediaStream = null;

	currentStates = {
		camera: 'none',
		microphone: 'none',
		sound: 'none',
		network: 'none',
	};

	showCompleted: boolean = false;
	localVideoStyle: any = {};
	micAnalyser = null;
	testSoundAnalyser: VisibaAudioAnalyser = null;
	evaluationText: string = this._translateService.get('LicenceHolder.Component.MediaTestMini.Phrase.DonePaymentMessage');
	audioContext: AudioContext;
	streamInited: boolean = false;
	isDestroyed: boolean = false;
	isReady: boolean = false;
	startedQueued: boolean = false;
	tests: { [name: string]: TestState } = {
		audio: 'none',
		video: 'none',
		microphone: 'none',
		network: 'completed',
	};
	private updateActiveDevices: Subscription;

	constructor(
		private _translateService: TranslateService,
		private _audioPlayerService: AudioPlayerService,
		private _ngZone: NgZone,
		public _spaLogger: SpaLogger,
		public _spaContext: SpaContext,
		private helper: Helper,
	) {
		super(_spaLogger, _spaContext, _translateService);

		this.updateActiveDevices = this.onUpdateActiveDevices.subscribe((update) => {
			this._ngZone.run(() => {
				const { device } = update;
				const deviceViewState = update.state === 'removed' ? 'failed' : 'start';

				switch (device) {
					case 'videoinput':
						this.updateVideo(this.chosenVideoinputDeviceId);
						this.setCurrentState('camera', deviceViewState);

						break;
					case 'audioinput':
						this.updateAudioInput(this.chosenAudioinputDeviceId);
						this.setCurrentState('microphone', deviceViewState);

						break;
					case 'audiooutput':
						this.updateAudioOutput(this.chosenAudiooutputDeviceId);
						this.setCurrentState('sound', deviceViewState);

						break;
				}
			});
		});
	}

	ngOnInit() {
		if (this.openOnStart === true) {
			this.start();
		}
	}

	ngAfterViewInit() {
		window.setTimeout(() => {
			this.isReady = true;
			if (this.startedQueued === true) {
				this.start();
			}
		}, 500);
	}

	ngOnDestroy() {
		this.stopStream();
		this.isDestroyed = true;
		this.updateActiveDevices.unsubscribe();
	}

	setCurrentState(object: string, state: TestState) {
		if (this.currentStates[object] === state) {
			return;
		}

		this.currentStates[object] = state;

		let completed = null;

		if (state === 'completed' && object !== 'evaluation') {
			if (
				this.currentStates['camera'] === 'completed' &&
				this.currentStates['microphone'] === 'completed' &&
				this.currentStates['sound'] === 'completed' &&
				this.currentStates['network'] === 'completed'
			) {
				this.setCurrentState('evaluation', 'start');
				this.helper.cookie.create('X-App-MediaTest', 'true');
				this.showCompleted = true;
				this.onEvaluationCompleteFunction();
			}
			completed = 0;
			Object.keys(this.currentStates).forEach((i) => {
				if (this.currentStates[i] === 'completed') completed++;
			});
		}
		this.stateUpdate.emit({
			completed: completed,
			total: Object.keys(this.currentStates).length,
			tests: this.currentStates,
			devices: { microphone: this.chosenAudioinputDeviceId, video: this.chosenVideoinputDeviceId },
		});
	}

	findAncestor(el, cls) {
		while ((el = el.parentElement) && !el.classList.contains(cls));
		return el;
	}

	public start(): void {
		this.mediaStream = null;
		this.micAnalyser = null;
		this.testSoundAnalyser = null;
		this.audioContext = null;
		this.streamInited = false;
		this.isDestroyed = false;

		if (!this.isReady) {
			this.startedQueued = true;
			return;
		}
		this.startedQueued = false;

		this.setCurrentState('camera', 'start');
		this.setCurrentState('microphone', 'start');
		this.setCurrentState('sound', 'start');
		this.setCurrentState('network', 'completed');

		if (this.helper.is.webRtcCompatable() && this.streamInited === false) {
			this.activeStream === null ? this.getStream() : this.useStream(this.activeStream);
		}
	}

	public startIfNeeded(): boolean {
		if (this.helper.cookie.get('X-App-MediaTest') === null) {
			this.start();
			return true;
		}
		return false;
	}

	public setEvaluation(
		evaluationText?: string,
		onEvaluationNextFunction?: () => void,
		onEvaluationCompleteFunction?: () => void,
	): void {
		this.evaluationText = evaluationText || this.evaluationText;
		this.onEvaluationNextFunction = onEvaluationNextFunction || this.onEvaluationCompleteFunction;
		this.onEvaluationCompleteFunction = onEvaluationCompleteFunction || this.onEvaluationCompleteFunction;
	}

	public close(): void {
		this.setCurrentState('camera', 'none');
		this.setCurrentState('microphone', 'none');
		this.setCurrentState('sound', 'none');
		this.setCurrentState('network', 'none');
		this.setCurrentState('evaluation', 'none');
		this.showCompleted = false;
		this.stopStream();
	}

	public stopStream() {
		if (this.mediaStream === null || this.activeStream !== null) return;

		if (this.audioContext !== null && typeof this.audioContext !== 'undefined') {
			this.audioContext.close();
			delete window['javascriptNode'];
			delete this.audioContext;
		}
		if (this.mediaStream !== null && typeof this.mediaStream !== 'undefined') {
			let tracks: MediaStreamTrack[] = this.mediaStream.getTracks();
			for (let i in tracks) {
				tracks[i].stop();
				this.mediaStream.removeTrack(tracks[i]);
			}
			delete this.mediaStream;
		}
	}

	async getStream() {
		this.streamInited = true;
		const constraints: MediaStreamConstraints = {
			audio: true,
			video: {
				width: 1280,
				height: 720,
				frameRate: 24,
			},
		};

		try {
			const mediaStream = await this.getMediaStream(constraints);
			this.devices = await this.getDeviceList();

			if (this.isDestroyed) {
				this.mediaStream = mediaStream;
				this.stopStream();

				return;
			}

			this.stopStream();

			this.mediaStream = mediaStream;

			window.setTimeout(() => {
				this.bindStream();
			});
		} catch (error) {
			this.parseError(error, 'MediaStream');
			this.streamInited = false;
		}
	}

	async updateAudioInput(trackID: string) {
		try {
			await this.updateAudioTrack(trackID);

			this.checkMicrophone();
		} catch (error) {}
	}

	async updateVideo(trackID: string) {
		try {
			await this.updateVideoTrack(trackID);
		} catch (error) {}
	}

	async updateAudioOutput(sinkId: string) {
		this._audioPlayerService.attachSinkId('/Images/Public/soundtest.mp3', sinkId);
	}

	async useStream(stream: MediaStream) {
		try {
			this.mediaStream = stream;
			this.devices = await this.getDeviceList();

			this.bindStream();

			this.streamInited = true;
		} catch (error) {
			console.error(error);
			this.streamInited = false;
		}
	}

	bindStream() {
		if (document.querySelector('.testCamera .videoLoaderIcon') !== null)
			document.querySelector('.testCamera .videoLoaderIcon').remove();

		let element = document.querySelector('.testCamera video') as HTMLVideoElement;
		element.muted = true;
		element.style.display = 'block';
		element.srcObject = this.mediaStream;

		element.addEventListener(
			'loadedmetadata',
			(e) => {
				this.setLocalVideoSize();
			},
			false,
		);

		this.checkMicrophone();
	}
	setLocalVideoSize() {
		let el: HTMLVideoElement = document.querySelector('.testCamera video') as HTMLVideoElement;
		if (el === null) return;

		if (el.videoWidth > el.videoHeight) {
			let ratio: number = (el.videoWidth / el.videoHeight) * 100;
			this.localVideoStyle = {
				width: ratio + '%',
				left: -((ratio - 100) / 2) + '%',
				position: 'absolute',
			};
		} else {
			let ratio: number = (el.videoHeight / el.videoWidth) * 100;
			this.localVideoStyle = {
				height: ratio + '%',
				top: -((ratio - 100) / 2) + '%',
				position: 'absolute',
			};
		}
	}
	toggleTestSound() {
		if (this._audioPlayerService.playing('/Images/Public/soundtest.mp3'))
			this._audioPlayerService.stop('/Images/Public/soundtest.mp3');
		else {
			const audio = this._audioPlayerService.play('/Images/Public/soundtest.mp3');
			audio.onended = () => {
				this.testSoundAnalyser.stop();
			};
			if (this.testSoundAnalyser === null) {
				this.testSoundAnalyser = new VisibaAudioAnalyser(
					audio,
					document.querySelector('media-test-mini .testSound .circles') as HTMLElement,
					this.helper,
				);
				this.testSoundAnalyser.init();
			}
			window.setTimeout(
				() => {
					//.5s for it to buffer on safari, I'm this nice
					this.testSoundAnalyser.start();
				},
				this.helper.is.safari() ? 500 : 0,
			);
		}
	}

	pauseAudio() {
		this._audioPlayerService.stop('/Images/Public/soundtest.mp3');
	}

	//---- check microphone -----
	checkMicrophone() {
		if (this.mediaStream.getAudioTracks().length === 0) return;

		if (this.audioContext !== null && typeof this.audioContext !== 'undefined') {
			document.querySelector('media-test-mini .testMicrophone .circles').textContent = '';
			this.audioContext.close();
			delete window['javascriptNode'];
		}

		this.audioContext = new AudioContext();

		const localMediaStreamID = this.mediaStream.getAudioTracks()[0].id;
		const element = document.querySelector('media-test-mini .testMicrophone .circles');
		const minAnimCircleSize = 0.4;
		const microphone = this.audioContext.createMediaStreamSource(this.mediaStream);
		const localMicChecker: number = window.setInterval(() => {
			if (maxLevel < 25) return;

			clearInterval(localMicChecker);
			this.setCurrentState('microphone', 'completed');
		}, 100);

		const micCheckerTimeouted: number = window.setTimeout(() => {
			if (maxLevel >= 25) return;

			this.setCurrentState('microphone', 'failed');
		}, 10 * 1000);
		let circles = [];
		let maxLevel = 0;

		window['javascriptNode'] = this.audioContext.createScriptProcessor(1024, 1, 1);

		this.micAnalyser = this.audioContext.createAnalyser();
		this.micAnalyser.smoothingTimeConstant = 0.5;
		this.micAnalyser.fftSize = 64;

		const binCount = this.micAnalyser.frequencyBinCount;
		const frequencyData = new Uint8Array(binCount);

		microphone.connect(this.micAnalyser);
		this.micAnalyser.connect(window['javascriptNode']);
		window['javascriptNode'].connect(this.audioContext.destination);

		for (let i = 0; i < binCount; i++) {
			const node = document.createElement('div');
			node.classList.add('circle');
			circles.push(node);
			element.appendChild(node);
		}

		const draw = () => {
			if (
				this.mediaStream === null ||
				this.mediaStream === undefined ||
				this.mediaStream.getAudioTracks().length === 0 ||
				localMediaStreamID !== this.mediaStream.getAudioTracks()[0].id
			) {
				clearInterval(localMicChecker);
				clearTimeout(micCheckerTimeouted);
				circles = [];

				return;
			}

			this.micAnalyser.getByteFrequencyData(frequencyData);

			for (var i = 0; i < circles.length; i++) {
				var circle = circles[i];

				circle.style.cssText =
					'transform:scale(' +
					((frequencyData[i] / 255) * (1 - minAnimCircleSize) + minAnimCircleSize) +
					');-webkit-transform:scale(' +
					((frequencyData[i] / 255) * (1 - minAnimCircleSize) + minAnimCircleSize) +
					')';
			}

			var sum = 0.0;
			for (var i = 0; i < frequencyData.length; ++i) sum += frequencyData[i];

			var instant = sum / frequencyData.length;
			maxLevel = Math.max(maxLevel, instant);

			window.requestAnimationFrame(draw);
		};
		window.requestAnimationFrame(draw);
	}

	// placeholder
	onEvaluationNextFunction() {}
	onEvaluationCompleteFunction() {}
}

type TestState = 'none' | 'failed' | 'completed' | 'start';
